import { render } from "./DesktopNav.vue?vue&type=template&id=e6c4f7dc"
import script from "./DesktopNav.vue?vue&type=script&lang=js"
export * from "./DesktopNav.vue?vue&type=script&lang=js"

import "./DesktopNav.vue?vue&type=style&index=0&id=e6c4f7dc&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__